import JarvisHttpService from "Jarvis/JarvisServices/JarvisHttpService";
import JarvisBaseSettingsService from "Jarvis/JarvisServices/JarvisBaseSettingsService";

export const ClientSystemPatronRetrieve = async ({ systemKey, pagination, client }) => {
  const retrieveService = "Lic/ClientSystemPatron/Retrieve";

  const { data } = await JarvisHttpService.post({
    url: JarvisBaseSettingsService.getApiEndPoint("Jarvis") + retrieveService,
    data: { systemKey, pagination, client },
  });

  return data;
};

/**
 * Clients for the account side's Licence step, by name and code. `patronIds` narrows the list to
 * the clients that are one of those patrons (the related account sides); empty offers every client.
 */
export const ClientSystemPatronClientRetrieve = async ({
  pageIndex,
  pageSize,
  where,
  patronIds,
}) => {
  const { data } = await JarvisHttpService.post({
    url:
      JarvisBaseSettingsService.getApiEndPoint("Jarvis") +
      "Lic/ClientSystemPatron/ClientRetrieveAsList",
    data: { pageIndex, pageSize, where, patronIds },
  });
  return data;
};

/** The systems a client already has, each with its current licence period and VT. */
export const ClientSystemPatronClientSystemRetrieve = async ({ ClientId }) => {
  const { data } = await JarvisHttpService.post({
    url:
      JarvisBaseSettingsService.getApiEndPoint("Jarvis") +
      "Lic/ClientSystemPatron/ClientSystemRetrieveAsList",
    data: { ClientId },
  });
  return data;
};

/** The client systems an account side is linked to. */
export const ClientSystemPatronRetrieveByPatron = async ({ PatronId, VT }) => {
  const { data } = await JarvisHttpService.post({
    url:
      JarvisBaseSettingsService.getApiEndPoint("Jarvis") +
      "Lic/ClientSystemPatron/RetrieveByPatron",
    data: { PatronId, VT },
  });
  return data;
};
